import {FC, useState,useEffect} from 'react';
import { Accordion } from 'react-bootstrap';
import ScrollToTopButton from '../../../../../shared/components/molecules/commons/scroll-to-top-button';
import {notificationService} from '../../../../../shared/services/notification-service';
import {AxiosError} from "axios/index";
import {RegistrationPersonnelHistoryService} from "../../../../../shared/services/Report/RegistrationPersonnelHistory/registration-personnel-history";
import {useParams} from 'react-router-dom';
import {Table} from 'react-bootstrap';
import TableHeaderOrdering, {Header} from "../../../../../shared/components/table-header-ordering";
import TableRowNoData from "../../../../../shared/components/molecules/commons/table-row-no-data";
import Moment from "moment";

const headers: Header[] = [
  {
    label: 'ประจำปี',
    field: '',
    order: null,
    isOrder: false,
  },
  {
    label: 'วันที่ได้รับเครื่องราชย์',
    field: '',
    order: null,
    isOrder: false,
  },
  {
    label: 'ประเภท',
    field: '',
    order: null,
    isOrder: false,
  },
  {
    label: 'เครื่องราชอิสริยาภรณ์',
    field: '',
    order: null,
    isOrder: false,
  }
];

const PersonnelInsignia: FC = () => {

  let {id} = useParams();
  const [data, setData] = useState<any>([]);

  const fetchData = async () => {
    try {
      const result = await RegistrationPersonnelHistoryService.getReportPersonnelHistoryDetail({id: id});
      setData(result);
    } catch (error) {
      const err = error as AxiosError;
      notificationService.dangerNotification('โหลดข้อมูลไม่สำเร็จ', err.message);
    }
  };

  const tableRowNoData = () => {
    if (data.insignia_histories?.length === 0) {
      return <TableRowNoData colspan={headers.length}/>;
    }
    return null;
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Accordion className="mt-3">
        <Accordion.Item eventKey="0">
          <Accordion.Header className={`text-mof-primary`}>
            <h5 className="text-mof-primary m-0">ประวัติเครื่องราชอิสริยาภรณ์</h5>
          </Accordion.Header>
          <Accordion.Body>
            <div className="overflow-auto mt-3">
              <Table bordered>
                <thead>
                  <TableHeaderOrdering headers={headers} onChangeOrder={() => {}} isShow={true}/>
                </thead>
                <tbody>
                  {data.insignia_histories?.map((data:any,index:any) => {
                    return <tr key={index}>
                      <td>{data.year ? data.year : '-'}</td>
                      <td>{data.date_of_award ? Moment(data.date_of_award).add(543, 'year').format('DD/MM/YYYY') : '-'}</td>
                      <td>{data.type ? data.type : '-'}</td>
                      <td>{data.name ? data.name : '-'}</td>
                    </tr>
                  })}
                  {tableRowNoData()}
                </tbody>
              </Table>
            </div>
            
            <div className="mt-3"><ScrollToTopButton/></div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default PersonnelInsignia;